import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

const REQUEST_ID_HEADER = 'x-request-id';

export interface Kcc20Referral {
  owner: string;
  walletAddress: string;
  code: string;
  referredByCode?: string;
  referredByOwner?: string;
  canAddReferredBy: boolean;
  totalReferred: number;
  last7d: number;
  last30d: number;
}

export interface Kcc20UpsertReferral {
  referredByCode?: string;
}

export interface Kcc20ReferralStats {
  code: string;
  totalReferred: number;
  last7d: number;
  last30d: number;
}

@Injectable({ providedIn: 'root' })
export class Kcc20ReferralApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  getMyReferral(requestId?: string): Observable<Kcc20Referral> {
    return this.http.get<Kcc20Referral>(
      `${this.baseUrl}/referrals/me`,
      this.options(requestId),
    );
  }

  upsertMyReferral(
    dto: Kcc20UpsertReferral = {},
    requestId?: string,
  ): Observable<Kcc20Referral> {
    return this.http.post<Kcc20Referral>(
      `${this.baseUrl}/referrals/me`,
      dto,
      this.options(requestId),
    );
  }

  getStats(code: string): Observable<Kcc20ReferralStats> {
    return this.http.get<Kcc20ReferralStats>(
      `${this.baseUrl}/referrals/stats`,
      {
        params: new HttpParams().set('code', code),
      },
    );
  }

  private options(requestId?: string) {
    return {
      withCredentials: true,
      ...headers(requestId),
    };
  }
}

function headers(requestId?: string) {
  return requestId
    ? {
        headers: {
          [REQUEST_ID_HEADER]: requestId,
        },
      }
    : {};
}
